import React from 'react';
import { Box, Typography, Grid, Button, Divider } from '@mui/material';
import ERPCard from '../components/Integration/ERPCard';
import { mockERPConnections } from '../data/mockData';
import AddIcon from '@mui/icons-material/Add';

const IntegrationPage: React.FC = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          ERP System Integration
        </Typography>
        <Button 
          variant="contained" 
          startIcon={<AddIcon />}
        >
          New Connection
        </Button>
      </Box>
      
      <Typography variant="body1" sx={{ mb: 4 }}>
        Connect Bruno AI with your enterprise systems to import financial data and export insights.
      </Typography>
      
      <Divider sx={{ mb: 4 }} />
      
      <Grid container spacing={3}>
        {mockERPConnections.map((connection) => (
          <Grid item xs={12} md={4} key={connection.id}>
            <ERPCard 
              system={connection.system}
              status={connection.status as 'Connected' | 'Disconnected'}
              lastSync={connection.lastSync}
              entities={connection.entities}
            />
          </Grid>
        ))}
        
        <Grid item xs={12} md={4}>
          <Box 
            sx={{ 
              border: '2px dashed #ccc', 
              borderRadius: 1, 
              height: '100%', 
              minHeight: 250,
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'center', 
              alignItems: 'center',
              p: 3
            }}
          >
            <AddIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" sx={{ mb: 1 }}>
              Add Integration
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              Connect to additional ERP systems or other data sources
            </Typography>
            <Button 
              variant="outlined" 
              sx={{ mt: 2 }}
              startIcon={<AddIcon />}
            >
              Connect
            </Button>
          </Box>
        </Grid>
      </Grid>
      
      <Box sx={{ mt: 6 }}>
        <Typography variant="h5" gutterBottom>
          Integration Settings
        </Typography>
        <Divider sx={{ mb: 3 }} />
        
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Synchronization Settings
            </Typography>
            
            <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 1, mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom>
                Auto-Sync Frequency
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Every 6 hours
              </Typography>
            </Box>
            
            <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 1 }}>
              <Typography variant="subtitle1" gutterBottom>
                Conflict Resolution
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Prefer latest
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>
              Data Mapping
            </Typography>
            
            <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 1, mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom>
                Default Entity Mappings
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Using standard mappings for SAP, Oracle, and Microsoft
              </Typography>
            </Box>
            
            <Box sx={{ bgcolor: 'background.paper', p: 2, borderRadius: 1 }}>
              <Typography variant="subtitle1" gutterBottom>
                Custom Field Mappings
              </Typography>
              <Typography variant="body2" color="text.secondary">
                3 custom field mappings configured
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default IntegrationPage;
